module.exports = __webpack_public_path__ + "img/hr-concrete-outer-corner.f04bb248.png";